export default "__VITE_ASSET__CGQY8n4L__"